export const UI_LANGUAGE_OPTIONS = ['en', 'cs'];

export const FALLBACK_LANGUAGE = 'en';

export const BOT_LANGUAGE_OPTIONS: string[] = [
    'en',
    'ar',
    'cs',
    'de',
    'el',
    'es',
    'hr',
    'pl',
    'ru',
    'sk',
    'tr',
    'uk',
    'lt',
    'hu',
    'fil',
    'pt',
    'ja',
    'et',
    'ro',
    'it',
    'bg',
    'sr',
    'kk',
    'sq',
    'mk',
    'vi',
];
